export class Ajuste {
    idajuste?:string;
    serie?:string;
    numero?:string;
    fecha?:string;
    motivo?:string;
    referencia?:string;
    estado?:string;
    idsucursal?:any;
    moneda?:string;
    tcambio?:number;
    tipo_ope?:string;
    idsucur2?:string;
    total?:number;
    personalc_id?:string;
    personalm_id?:string;
    dtmodificacion?:number;

    constructor(){}
}
